// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1391 ? "upcoming-sports" : chunkId) + "." + {"1391":"97c835b0ac309989","3237":"ca3eac5ce10fd9cc","5897":"0dc1cf1b328f2217","8409":"810e356faee5f61c","8765":"47ec8d4fcdb8057c"}[chunkId] + ".js";
};